import { css } from "../../css/util.compose-css";

export const list = css`
  margin: 0;
  padding: 0;

  list-style-type: none;
`;
